/**
 * 受注一覧 運搬完了報告
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifests/completion_processes`

 const manifest_completion_process = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 運搬完了報告初期情報
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    show ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 運搬完了報告登録
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},

 }

 export default manifest_completion_process
